import produce from 'immer'
import * as types from 'Redux/Types/ReportTypes'

const initialState = {
  auditLogs: [],
  creatingReport: false,
  deletingReport: false,
  fetchingAuditLogs: false,
  fetchingReportExpenses: false,
  fetchingReports: false,
  reportDownloadURL: null,
  reportExpenses: [],
  reports: [],
  updatingReport: false,
  creatingExportReport: false,
  createTransactionReport: false,
}

const clearDownloadReportURL = (draft) => {
  draft.reportDownloadURL = null
  draft.reportExportDownloadURL = null
  draft.reportTransactionDownloadURL = null
}

const clearReportExpenses = (draft) => {
  draft.reportExpenses = []
}

const createReport = (draft) => {
  draft.creatingReport = true
}

const createReportFailed = (draft) => {
  draft.creatingReport = false
}

const createReportSucceeded = (draft, payload) => {
  draft.creatingReport = false
  draft.reportDownloadURL = payload.url
}

const createExportReport = (draft) => {
  draft.creatingExportReport = true
}

const createExportReportFailed = (draft) => {
  draft.creatingExportReport = false
}

const createExportReportSucceeded = (draft, payload) => {
  draft.creatingExportReport = false
  draft.reportExportDownloadURL = payload.url
}

const createTransactionReport = (draft) => {
  draft.createTransactionReport = true
}

const createTransactionReportFailed = (draft) => {
  draft.createTransactionReport = false
}

const createTransactionReportSucceeded = (draft, payload) => {
  draft.createTransactionReport = false
  draft.reportTransactionDownloadURL = payload.url
}

const deleteReport = (draft) => {
  draft.deletingReport = true
}

const deleteReportFailed = (draft) => {
  draft.deletingReport = false
}

const deleteReportSucceeded = (draft, payload) => {
  draft.deletingReport = false
}

const fetchAuditLogs = (draft) => {
  draft.fetchingAuditLogs = true
}

const fetchAuditLogsFailed = (draft) => {
  draft.fetchingAuditLogs = false
}

const fetchAuditLogsSucceeded = (draft, { data, next, previous }) => {
  draft.fetchingAuditLogs = false
  draft.nextAuditLogs = next
  draft.previousAuditLogs = previous
  draft.auditLogs = data
}

const fetchReportExpenses = (draft) => {
  draft.fetchingReportExpenses = true
}

const fetchReportExpensesFailed = (draft) => {
  draft.fetchingReportExpenses = false
}

const fetchReportExpensesSucceeded = (draft, { data, next, previous }) => {
  draft.fetchingReportExpenses = false
  draft.nextReportExpenses = next
  draft.previousReportExpenses = previous
  draft.reportExpenses = data
}

const fetchReports = (draft) => {
  draft.fetchingReports = true
}

const fetchReportsFailed = (draft) => {
  draft.fetchingReports = false
}

const fetchReportsSucceeded = (draft, { data, next, previous }) => {
  draft.fetchingReports = false
  draft.next = next
  draft.previous = previous
  draft.reports = data
}

const updateReport = (draft) => {
  draft.updatingReport = true
}

const updateReportFailed = (draft) => {
  draft.updatingReport = false
}

const updateReportSucceeded = (draft) => {
  draft.updatingReport = false
}

const reportsReducer = (state = initialState, action) => {
  return produce(state, (draft) => {
    const { type, payload } = action

    switch (type) {
      case types.CLEAR_DOWNLOAD_REPORT_URL:
        return clearDownloadReportURL(draft)

      case types.CLEAR_REPORT_EXPENSES:
        return clearReportExpenses(draft)

      case types.CREATE_REPORT:
        return createReport(draft)

      case types.CREATE_REPORT_FAILED:
        return createReportFailed(draft)

      case types.CREATE_REPORT_SUCCEEDED:
        return createReportSucceeded(draft, payload)

      case types.CREATE_EXPORT_REPORT:
        return createExportReport(draft)

      case types.CREATE_EXPORT_REPORT_FAILED:
        return createExportReportFailed(draft)

      case types.CREATE_EXPORT_REPORT_SUCCEEDED:
        return createExportReportSucceeded(draft, payload)

      case types.CREATE_TRANSACTION_REPORT:
        return createTransactionReport(draft)

      case types.CREATE_TRANSACTION_REPORT_FAILED:
        return createTransactionReportFailed(draft)

      case types.CREATE_TRANSACTION_REPORT_SUCCEEDED:
        return createTransactionReportSucceeded(draft, payload)

      case types.DELETE_REPORT:
        return deleteReport(draft)

      case types.DELETE_REPORT_FAILED:
        return deleteReportFailed(draft)

      case types.DELETE_REPORT_SUCCEEDED:
        return deleteReportSucceeded(draft, payload)

      case types.FETCH_AUDIT_LOGS:
        return fetchAuditLogs(draft)

      case types.FETCH_AUDIT_LOGS_FAILED:
        return fetchAuditLogsFailed(draft)

      case types.FETCH_AUDIT_LOGS_SUCCEEDED:
        return fetchAuditLogsSucceeded(draft, payload)

      case types.FETCH_REPORT_EXPENSES:
        return fetchReportExpenses(draft)

      case types.FETCH_REPORT_EXPENSES_FAILED:
        return fetchReportExpensesFailed(draft)

      case types.FETCH_REPORT_EXPENSES_SUCCEEDED:
        return fetchReportExpensesSucceeded(draft, payload)

      case types.FETCH_REPORTS:
        return fetchReports(draft)

      case types.FETCH_REPORTS_FAILED:
        return fetchReportsFailed(draft)

      case types.FETCH_REPORTS_SUCCEEDED:
        return fetchReportsSucceeded(draft, payload)

      case types.UPDATE_REPORT:
        return updateReport(draft)

      case types.UPDATE_REPORT_FAILED:
        return updateReportFailed(draft)

      case types.UPDATE_REPORT_SUCCEEDED:
        return updateReportSucceeded(draft, payload)

      // no default
    }
  })
}

export default reportsReducer
